import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { formatBpsValue } from "~/utils/formatBpsValue";
import { DataGridCellVal } from "~/components/DataGrid/DataGridCellValue";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const MANAGEMENT_FEE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.totalManagementFeeBps,
    sortsOn: AssetColumns.totalManagementFeeBps,
    label: (
        <>
            Management
            <br />
            Fees
        </>
    ),
    tooltip: CatalogReferenceDataSlugs.total_management_fee_bps,
    type: ColumnTypes.percent,
    width: 160,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        if (item.isAsset) {
            // Return hard-coded value for BUIDL
            // TODO - remove this!
            const isBuidl = item.ticker?.toLowerCase() === "buidl";
            if (isBuidl) {
                return "0.20-0.50%";
            }

            return (
                <DataGridCellVal
                    value={formatBpsValue(item.total_management_fee_bps)}
                    size="md"
                    type="percent"
                />
            );

            // NOTE - revert to this when we remove the isBuidl check
            // ALSO - revert `render` to `cellValue`
            // ALSO - revert `return <Emdash />` to `return null` below
            // return formatBpsValue(item.total_management_fee_bps);
        }

        // return null;
        return <Emdash />;
    },
};
